var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCsvPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 245,
    viewBox: "0 0 245 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M122.5 244C189.603 244 244 189.603 244 122.5C244 55.3974 189.603 1 122.5 1C55.3974 1 1 55.3974 1 122.5C1 189.603 55.3974 244 122.5 244Z",
    fill: "white",
    stroke: "#4DAF70",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5256 59.3198H149.974L165.356 79.4028V168.166H77.5256V59.3198Z",
    stroke: "#E3E6EF",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.593 60.5894L163.716 78.8195H148.322V60.5894H150.593Z",
    stroke: "#E3E6EF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.995 187.535C174.372 187.239 187.871 174.682 187.871 159.235C187.871 143.603 175.199 130.93 159.566 130.93C159.121 130.93 158.677 130.94 158.237 130.961C153.674 118.011 141.331 108.73 126.821 108.73C111.695 108.73 98.9255 118.814 94.8669 132.625C91.8492 131.528 88.5921 130.93 85.1952 130.93C69.5627 130.93 56.89 143.603 56.89 159.235C56.89 174.682 69.2638 187.239 84.6402 187.535L85.7661 187.541H160.121L158.995 187.535Z",
    fill: "#4DAF70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.963 158.77L113.432 165.301C112.037 166.696 109.775 166.696 108.38 165.301C106.986 163.906 106.986 161.645 108.38 160.25L121.009 147.622C121.706 146.924 122.62 146.575 123.534 146.575C124.448 146.575 125.363 146.924 126.06 147.622L138.688 160.25C140.083 161.645 140.083 163.906 138.688 165.301C137.293 166.696 135.032 166.696 133.637 165.301L127.106 158.77V188.002H119.963V158.77Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCsvPlaceholder);
export default __webpack_public_path__ + "static/media/upload-csv-placeholder.6be30ee3f422c49c72a19f87d9ad7970.svg";
export { ForwardRef as ReactComponent };